import React from 'react';

import Elections from 'app/components/election/Elections';

export default function Recommendations(props) {
    return (
        <Elections variant='recommendation' variantTitle='Recommendations'/>
    )
}
